import { MapPin } from "lucide-react";

interface NearbyItem {
  name: string;
  distance: string;
  description: string;
  href?: string;
}

const DEFAULT_NEARBY: NearbyItem[] = [
  {
    name: "Schlitterbahn Waterpark",
    distance: "~10 min drive",
    description:
      "World-famous waterpark in downtown New Braunfels — easy day trip from your cabana or glamping tent.",
  },
  {
    name: "Historic Gruene, TX",
    distance: "~15 min drive",
    description:
      "Old Texas dance hall (Gruene Hall), shops, and riverfront restaurants. A favorite evening stop after a day on the river.",
  },
  {
    name: "Natural Bridge Caverns",
    distance: "~25 min drive",
    description:
      "Texas's largest commercial caverns and zip-line park — a great rainy-day or shoulder-season option.",
  },
  {
    name: "Hill Country Wineries",
    distance: "~30–45 min drive",
    description:
      "Dripping Springs, Boerne and Comfort wineries are an easy detour from River Road — perfect for parents on a kid-free afternoon.",
  },
  {
    name: "Landa Park & Comal River",
    distance: "~10 min drive",
    description:
      "Spring-fed Comal River, paddleboats, and a kid-friendly park in the heart of New Braunfels.",
  },
  {
    name: "Canyon Lake",
    distance: "~20 min drive",
    description:
      "Texas's clearest lake — boating, swimming and overlooks just up River Road from Son's properties.",
  },
];

export const WhatsNearby = ({
  items = DEFAULT_NEARBY,
  heading = "What's Nearby",
  intro,
}: {
  items?: NearbyItem[];
  heading?: string;
  intro?: string;
}) => {
  return (
    <section className="section-padding bg-cream/40">
      <div className="container-narrow mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-charcoal mb-3">
            {heading}
          </h2>
          {intro && (
            <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">{intro}</p>
          )}
          {!intro && (
            <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">
              Son's Guadalupe sits in the heart of the Texas Hill Country, minutes from
              New Braunfels' best-known attractions.
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <div
              key={item.name}
              className="bg-white rounded-2xl p-6 shadow-soft hover:shadow-elevated transition-shadow"
            >
              <div className="flex items-center gap-2 text-teal mb-2">
                <MapPin className="w-4 h-4" />
                <span className="text-xs uppercase tracking-wider font-semibold">
                  {item.distance}
                </span>
              </div>
              <h3 className="font-heading text-xl font-bold text-charcoal mb-2">
                {item.name}
              </h3>
              <p className="text-charcoal/70 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
